import { Box, Button } from '@mui/material'
import React from 'react'
import { useNavigate } from 'react-router-dom'

function AdminPanelHome() {
  const navigateTo = useNavigate();

  return (
    <Box paddingX={1}>
      <Button variant='contained' onClick={()=>navigateTo("/goztepe")} sx={{marginY:3, height:200, fontSize:26}} fullWidth >GÖZTEPE ŞUBESİNDEKİ ÜRÜNLERİ DÜZENLE</Button>
      <Button variant='contained' onClick={()=>navigateTo("/atakent")} sx={{ height:200, fontSize:26}} fullWidth >ATAKENT ŞUBESİNDEKİ ÜRÜNLERİ DÜZENLE</Button>
    </Box>
  )
}

export default AdminPanelHome